export const COLLECTION_TABLE_HEADER = [
  "Фото",
  "Название",
  "Описание",
  "Статус",
];
